/**
 * CRA at http://localhost:3000 + API at http://api.localhost = different sites; Chrome drops
 * session cookies for that pattern. Local docker should use docker-compose.local.yml and
 * http://localhost:4002 / :3001 / :4003. If REACT_APP_* was baked in as *.localhost, rewrite
 * at runtime in development so auth works without a full rebuild.
 */
function warnOnce(key: string, message: string) {
  if (typeof window === 'undefined') return;
  const w = window as unknown as { __zparDevUrlWarns?: Set<string> };
  if (!w.__zparDevUrlWarns) w.__zparDevUrlWarns = new Set();
  if (w.__zparDevUrlWarns.has(key)) return;
  w.__zparDevUrlWarns.add(key);
  console.warn(message);
}

export function devDockerLoopbackApiOrigin(fromEnv: string | undefined): string {
  if (process.env.NODE_ENV !== 'development') {
    return (fromEnv?.trim().replace(/\/$/, '') || '');
  }
  const trimmed = fromEnv?.trim().replace(/\/$/, '') || '';
  const fallback = 'http://localhost:4002';
  if (trimmed.includes('api.localhost')) {
    warnOnce(
      'api',
      '[zpar-fe] REACT_APP_API points at api.localhost — session cookies from localhost:3000 will not stick in Chrome. Using http://localhost:4002. Fix .env, run docker compose … -f docker-compose.local.yml, then restart npm start.'
    );
    return fallback;
  }
  return trimmed || fallback;
}

export function devDockerLoopbackGameSocket(fromEnv: string | undefined): string {
  if (process.env.NODE_ENV !== 'development') {
    return fromEnv?.trim() || '';
  }
  const trimmed = fromEnv?.trim() || '';
  const fallback = 'http://localhost:3001';
  if (trimmed.includes('game.localhost')) {
    warnOnce(
      'socket-game',
      '[zpar-fe] REACT_APP_SOCKET uses game.localhost — use http://localhost:3001 with docker-compose.local.yml. Rewriting for this session; restart npm start after fixing .env.'
    );
    return fallback;
  }
  return trimmed || fallback;
}

export function devDockerLoopbackSpectateSocket(fromEnv: string | undefined): string {
  if (process.env.NODE_ENV !== 'development') {
    return fromEnv?.trim() || '';
  }
  const trimmed = fromEnv?.trim() || '';
  const fallback = 'http://localhost:4003';
  if (trimmed.includes('spectate.localhost')) {
    warnOnce(
      'socket-spectate',
      '[zpar-fe] REACT_APP_SOCKET_SPECTATE uses spectate.localhost — use http://localhost:4003. Rewriting; restart npm start after fixing .env.'
    );
    return fallback;
  }
  return trimmed || fallback;
}
